import { LoadingOutlined } from '@ant-design/icons'
import { observer } from 'mobx-react-lite'
import { FC, ReactNode } from 'react'
import Modal from '../../../components/Modal'
import styles from './OptionsModal.module.scss'

export interface OptionsModalProps {
	height?: string
	openned: boolean
	title: string
	children: ReactNode
	onClose: () => void
	done?: string
	doneLoading?: boolean
	onDone?: () => void
	danger?: string
	dangerLoading?: boolean
	onDanger?: () => void
	actionClassName?: string
}

const OptionsModal: FC<OptionsModalProps> = ({
	height,
	openned,
	title,
	children,
	onClose,
	done,
	doneLoading = false,
	onDone,
	danger,
	dangerLoading = false,
	onDanger,
	actionClassName,
}) => {
	const actionCount = Number(done != null) + Number(danger != null)
	const actions = done != null || danger != null ? (
		<div className={`${styles.options_actions} ${actionClassName ?? ''}`}>
			{done != null && (
				<button
					type='button'
					style={actionCount > 1 ? { width: 'calc(50% - 4px)', maxWidth: 'none' } : undefined}
					disabled={doneLoading}
					onClick={onDone}
				>
					{doneLoading ? <LoadingOutlined spin /> : done}
				</button>
			)}
			{danger != null && (
				<button
					type='button'
					className={styles.danger}
					style={actionCount > 1 ? { width: 'calc(50% - 4px)', maxWidth: 'none' } : undefined}
					disabled={dangerLoading}
					onClick={onDanger}
				>
					{dangerLoading ? <LoadingOutlined spin /> : danger}
				</button>
			)}
		</div>
	) : undefined

	return (
		<Modal
			visible={openned}
			title={title}
			content={<div className={styles.options_content}>{children}</div>}
			footer={actions}
			onClose={onClose}
			closeOnBackdrop
			stickyHeaderFooter={actions != null}
			style={{
				width: '490px',
				maxWidth: 'calc(100vw - 48px)',
				...(height === 'auto' ? { maxHeight: '90vh' } : {}),
			}}
		/>
	)
}

export default observer(OptionsModal)
